import {ChangeEvent, useCallback, useEffect} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import {DialogClose} from '../../../../components/dialogs/DialogFrame/DialogClose';
import UploadFiles, {
  IUploadFileType,
} from '../../../../components/styles/UploadFiles';
import {IDemoAdSpotProps} from '../../../../dto/demoStingerFulfilment.dto';
type Props = {
  open: boolean;
  setOpen: (val: boolean) => void;
  files: IUploadFileType[];
  setFiles: React.Dispatch<React.SetStateAction<IUploadFileType[]>>;
  adSpot: IDemoAdSpotProps;
  setAdSpot: React.Dispatch<React.SetStateAction<IDemoAdSpotProps>>;
  handleAdd: () => void;
  handleCancel: () => void;
};
const DialogAdSpot = ({
  open,
  setOpen,
  files,
  setFiles,
  adSpot,
  setAdSpot,
  handleAdd,
  handleCancel,
}: Props) => {
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const handleChanges = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const {name, value} = e.target;
      setAdSpot(prevAdSpot => ({...prevAdSpot, [name]: value}));
    },
    [setAdSpot],
  );
  useEffect(() => {
    setAdSpot(prevAdSpot => ({
      ...prevAdSpot,
      file: files,
    }));
  }, [files, setAdSpot]);
  const isAdSpotValid = useCallback(() => {
    const {id, name, adspot, file} = adSpot;
    return id !== 0 && name && adspot && file && file.length > 0;
  }, [adSpot]);
  return (
    <Dialog
      open={open}
      maxWidth='sm'
      fullWidth
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogTitle>
        <Typography className='alignCenter'>Demo Stinger AdSpot</Typography>
        <DialogClose onClose={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Stack direction='column'>
          <TextField
            value={adSpot.name}
            label='Script name'
            name='name'
            onChange={handleChanges}></TextField>
          <TextField
            multiline
            value={adSpot.adspot}
            rows={4}
            name='adspot'
            onChange={handleChanges}
            placeholder='AdSpot'></TextField>
          <UploadFiles setFiles={setFiles} files={files} max={1} />
        </Stack>
      </DialogContent>
      <DialogActions className='flex items-center justify-center'>
        <Button
          variant='contained'
          onClick={handleAdd}
          disabled={!isAdSpotValid()}>
          Add
        </Button>
        <Button variant='outlined' color='info' onClick={handleCancel}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogAdSpot;
